import React from 'react';
import { PractitionerProfileCardComponent } from '../../../components/Cards';
import { useOrganization } from '../../../contexts/organization';
import { usePractitioner } from '../../../contexts/practitioner';
const capitalize = (s: string | undefined) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};
const PractitionerProfileCard = () => {
  const {
    getDisplayName,
    getEmail,
    getFirstName,
    getGender,
    getLastName,
    getRoles,
    isActive,
    loading,
  } = usePractitioner();
  const { organization } = useOrganization();
  const roles =
    (organization &&
      getRoles(organization.id)
        .filter(r => r.active)
        .map(r => r.display)
        .join(', ')) ||
    'No Roles found for this organization';
  return (
    <PractitionerProfileCardComponent
      displayName={getDisplayName()}
      loading={loading}
      familyName={getLastName()}
      active={isActive()}
      firstName={getFirstName()}
      gender={capitalize(getGender())}
      email={getEmail() || 'Unknown'}
      practitionerRole={roles}
    />
  );
};

export default PractitionerProfileCard;
